import { useLazyQuery, useMutation } from "@apollo/client"
import { createContactMessageResponse, deleteUserResponse, getAdminUserStatusStatsResponse, getAdminUserStatusStatsResponseNestedBluePrint, getUserStatusStatsResponse, getUserStatusStatsResponseNestedBluePrint, ICreateContactMessageRequest, ICreateContactMessageResponse, IDeleteUserRequest, IDeleteUserResponse, IGetAdminUserStatusStatsResponse, IGetAdminUserStatusStatsResponseNestedBluePrint, IGetNotificationCountRequest, IGetNotificationCountResponse, IGetNotificationRequest, IGetNotificationResponse, IGetNotificationResponseBluePrint, IGetNotificationsRequest, IGetNotificationsResponse, IGetNotificationsResponseBluePrint, IGetUserRequest, IGetUserResponse, IGetUserResponseBluePrint, IGetUsersRequest, IGetUsersResponse, IGetUsersResponseBluePrint, IGetUserStatusStatsResponse, IGetUserStatusStatsResponseNestedBluePrint, IMeRequest, IMeResponse, IMeResponseBluePrint, IUpdateUserRequest, IUpdateUserResponse, IUpdateUserResponseBluePrint, notificationQuery, userAdminQuery, userQuery, userStatusCountsQuery } from "./types"
import { schema } from "./schema"
import { gqlQueryStringBuilder } from "utils"

export const useUserService = () => {

    
    
    /*
    const [getNotifications] = useLazyQuery<{ getNotifications: IGetNotificationsResponse}, IGetNotificationsRequest>(
        schema.getNotifications(
            gqlQueryStringBuilder<IGetNotificationsResponse, IGetNotificationsResponseBluePrint>(
                ["notifications"], {
                    notifications: notificationQuery
                }
            )
        )
    )
    
    const [getNotification] = useLazyQuery<{ getNotification: IGetNotificationResponse}, IGetNotificationRequest>(
        schema.getNotification(
            gqlQueryStringBuilder<IGetNotificationResponse, IGetNotificationResponseBluePrint>(
                ["notification"], {
                    notification: notificationQuery
                }
            )
        )
    )
    */
    
    const [getNotificationCount] = useLazyQuery<{ getNotificationCount: IGetNotificationCountResponse}, IGetNotificationCountRequest>(
        schema.getNotificationCount(
            gqlQueryStringBuilder<IGetNotificationCountResponse>(
                ["count"]
            )
        )
    )
    const [getAdminUserStatusStats] = useLazyQuery<{getAdminUserStatusStats: IGetAdminUserStatusStatsResponse}>(
        schema.getAdminUserStatusStats(
            gqlQueryStringBuilder<IGetAdminUserStatusStatsResponse, IGetAdminUserStatusStatsResponseNestedBluePrint>(
                getAdminUserStatusStatsResponse, getAdminUserStatusStatsResponseNestedBluePrint
            )
        )
    )
    const [getUserStatusStats] = useLazyQuery<{getUserStatusStats: IGetUserStatusStatsResponse}>(
        schema.getUserStatusStats(
            gqlQueryStringBuilder<IGetUserStatusStatsResponse, IGetUserStatusStatsResponseNestedBluePrint>(
                getUserStatusStatsResponse, getUserStatusStatsResponseNestedBluePrint
            )
        )
    )
    const [updateUser] = useMutation<{updateUser: IUpdateUserResponse}, IUpdateUserRequest>(
        schema.updateUser(
            gqlQueryStringBuilder<IUpdateUserResponse, IUpdateUserResponseBluePrint>(
                ["user"], {
                    user: userQuery,
                    userAdmin: userAdminQuery
                }
            )
        )
    )
    const [deleteUser] = useMutation<{deleteUser: IDeleteUserResponse}, IDeleteUserRequest>(
        schema.deleteUser(
            gqlQueryStringBuilder<IDeleteUserResponse>(
                deleteUserResponse
            )
        )
    )
         
    const [getUser] = useLazyQuery<{getUser: IGetUserResponse}, IGetUserRequest>(
        schema.getUser(
            gqlQueryStringBuilder<IGetUserResponse, IGetUserResponseBluePrint>(
                ["user"], {
                    user: userQuery,
                    userAdmin: userAdminQuery,
                }
            )
        )
    )
       
    const [getUsers] = useLazyQuery<{getUsers: IGetUsersResponse}, IGetUsersRequest>(
        schema.getUsers(
            gqlQueryStringBuilder<IGetUsersResponse, IGetUsersResponseBluePrint>(
                ["users", "total"], {
                    users: userQuery,
                    userAdmin: userAdminQuery,
                }
            )
        )
    )
        
    const [me] = useLazyQuery<{me: IMeResponse}>(
        schema.me(
            gqlQueryStringBuilder<IMeResponse, IMeResponseBluePrint>(
                ["user"], {
                    user: userQuery,
                    userAdmin: userAdminQuery,
                }
            )
        )
    ) 

    const [createContactUs] = useMutation<{contactUs: ICreateContactMessageResponse}, ICreateContactMessageRequest>(
        schema.contactUs(
            gqlQueryStringBuilder<ICreateContactMessageResponse>(
                createContactMessageResponse
            )
        )
    )
    return {
        me,
        getUsers,
        getUser,
        updateUser,
        deleteUser,
        getNotificationCount,
        getAdminUserStatusStats,
        getUserStatusStats,
        createContactUs
    //     getNotification,
    //     getNotifications,
    }
}